export enum DisabledTooltipText {
	StillProcessing = "Processing is in session. We appreciate your patience.",
	FeatureDisabled = "This feature is disabled for this article.",
}